var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTuichudenglu = function SvgTuichudenglu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.804 0a.484.484 0 0 1 0 .967H1.97v14.08h8.84a.476.476 0 0 1 0 .953h-8.84C1.436 16 1 15.512 1 14.913V1.087C1 .487 1.436 0 1.97 0Zm.896 4.517a.433.433 0 0 1 .445.133l2.721 2.989a.556.556 0 0 1 0 .723l-2.721 2.989a.433.433 0 0 1-.444.132.483.483 0 0 1-.326-.355.535.535 0 0 1 .12-.487l1.946-2.138H6.502a.502.502 0 1 1 0-1.005h6.94l-1.948-2.139a.535.535 0 0 1-.12-.487.483.483 0 0 1 .326-.355Z",
    fill: "#333",
    fillRule: "nonzero"
  })));
};

export default SvgTuichudenglu;